// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"591":"36e93b9a","664":"ba80fe24","787":"53621415"}[chunkId] + ".chunk.js";
};